// Module
var code = "<template>\n    <router-view></router-view>\n</template>";
// Exports
export default code;